import styled, { css } from 'styled-components';
import { colors, monokaiBackground } from 'global/colors';

export const TestTitle = styled.h1`
  font-weight: bold;
  ${({ isDarkMode }) => {
    return css`
      color: ${isDarkMode ? colors.fsCyan : colors.fsDarkBlue};
    `;
  }}
`;

export const QuillContainer = styled.div`
  ${({ isDarkMode }) => {
    return css`
      background-color: ${isDarkMode ? colors.lightGray : colors.white};
    `;
  }}
`;

export const DescriptionContainer = styled.div`
  overflow-y: hidden;
  height: 100%;
  ${({ isDarkMode }) => {
    return css`
      background-color: ${isDarkMode ? monokaiBackground : colors.white};
    `;
  }}
`;

export const DescriptionScrollContainer = styled.div`
  overflow-y: auto;
  height: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
`;

export const DescriptionText = styled.div`
  * img {
    max-width: 100%;
  }

  ${({ isDarkMode }) =>
    !isDarkMode &&
    css`
      color: ${colors.darkBlue2};
      > :is(h1, h2, h3, h4, h5, h6) {
        color: ${colors.fsDarkBlue};
      }
    `}
  ${({ isDarkMode }) =>
    isDarkMode &&
    css`
      color: ${colors.lightGray} !important;

      * p {
        color: ${colors.lightGray} !important;
      }
      * span {
        color: ${colors.lightGray} !important;
      }
      > :is(h1, h2, h3, h4, h5, h6) {
        color: ${colors.fsCyan} !important;
        span {
          color: ${colors.fsCyan} !important;
        }
      }
    `}
`;
